import DOMPurify from 'dompurify'

/** Utility functions for helping with DOM stuff */

/**
 * Create a DOM element from an HTML string.
 *
 * @param {string} elementToCreate - HTML string representing the element to create.
 * @returns {Element} - DOM element created from the HTML string, or an empty <div> with an inline style to hide it if <template> is not supported.
 */
export function htmlToElement(elementToCreate) {
  const template = document.createElement('template')
  template.innerHTML = elementToCreate.trim()
  return 'content' in template
    ? template.content.firstChild
    : (() => {
        const emptyDiv = document.createElement('div')
        emptyDiv.style.display = 'none'
        return emptyDiv
      })()
}

/**
 * Simplify adding an element after another element in the DOM
 *
 * @param {object} newNode - New element to be added after the reference element
 * @param {object} referenceNode - Existing element to add the new element after
 */
export function insertAfter(newNode, referenceNode) {
  // in the case that the reference node is the last element, nextSibling will
  // return null and insertBefore will just add the new element at the end
  referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling)
}

/**
 * Decode HTML encoded values using a temporary textarea element.
 * Created to be used in conjunction with DOMPurify sanitize.
 *
 * @param {string} toDecode - Text to decode
 * @return {string} - Text with HTML decoded
 */
export function decodeHTML(toDecode) {
  const sacrificialTextArea = document.createElement('textarea')
  sacrificialTextArea.innerHTML = toDecode
  return sacrificialTextArea.value
}

/**
 * Cleanse and HTML decode some text
 *
 * @param {string} dirty - Text to cleanse and decode
 * @return {string} - Cleansed and decoded text
 */
export function cleanseText(dirty) {
  // using type coersion because in Chrome 77, DOMPurify no longer returns a string
  return decodeHTML(DOMPurify.sanitize(dirty) + '')
}

/**
 * Scroll Vue Element to the to of it's container
 * @param {object | null} ref - Vue ref to scroll
 */
export function scrollRefToTop(ref) {
  if (ref) {
    ref.scrollTop = 0
  }
}
